import { logoHorizontal } from "@rageeb/frontend-lib";
import { FC } from "react";
import { useNavigate } from "react-router-dom";
import { Button } from "@/components/buttons/button";
import { DASHBOARD_ROUTE } from "@/constants/routes";
import "./styles.scss";

type NotFoundPageProps = {
	module?: string;
	url?: string;
};

const NotFoundPage: FC<NotFoundPageProps> = ({
	module = "dashboard",
	url = DASHBOARD_ROUTE,
}) => {
	const navigate = useNavigate();
	return (
		<div className="page-not-found">
			<img src={logoHorizontal} alt="Focal's logo" className="logo" />

			<svg
				width="252"
				height="310"
				viewBox="0 0 252 310"
				fill="none"
				xmlns="http://www.w3.org/2000/svg"
				style={{
					position: "absolute",
					top: "0",
					left: "-20px",
					opacity: 0.5,
				}}
			>
				<g filter="url(#filter0_b_2688_26451)">
					<path
						d="M243.526 117.007C259.137 101.455 251.957 74.861 230.602 69.1391L-22.0466 1.44204C-43.4022 -4.28018 -62.9159 15.1611 -57.1724 36.4348L10.7812 288.124C16.5258 309.398 43.2195 316.551 58.8304 300.999L243.526 117.007Z"
						fill="url(#paint0_radial_2688_26451)"
						fillOpacity="0.4"
					/>
				</g>
				<defs>
					<filter
						id="filter0_b_2688_26451"
						x="-68.1895"
						y="-9.57123"
						width="330.119"
						height="328.943"
						filterUnits="userSpaceOnUse"
						colorInterpolationFilters="sRGB"
					>
						<feFlood floodOpacity="0" result="BackgroundImageFix" />
						<feGaussianBlur in="BackgroundImageFix" stdDeviation="5" />
						<feComposite
							in2="SourceAlpha"
							operator="in"
							result="effect1_backgroundBlur_2688_26451"
						/>
						<feBlend
							mode="normal"
							in="SourceGraphic"
							in2="effect1_backgroundBlur_2688_26451"
							result="shape"
						/>
					</filter>
					<radialGradient
						id="paint0_radial_2688_26451"
						cx="0"
						cy="0"
						r="1"
						gradientUnits="userSpaceOnUse"
						gradientTransform="translate(81.6252 100.662) rotate(103.808) scale(214.073 213.602)"
					>
						<stop stopColor="#F106F5" stopOpacity="0.1" />
						<stop offset="1" stopColor="#032BFF" stopOpacity="0.8" />
					</radialGradient>
				</defs>
			</svg>

			<svg
				width="240"
				height="199"
				viewBox="0 0 240 199"
				fill="none"
				xmlns="http://www.w3.org/2000/svg"
				style={{
					position: "absolute",
					top: "0",
					right: "0",
					opacity: 0.5,
				}}
			>
				<g opacity="0.15" filter="url(#filter0_b_3130_23544)">
					<rect
						width="217.65"
						height="217.65"
						rx="73.5809"
						transform="matrix(0.366854 0.930278 0.930278 -0.366854 -21 17.8458)"
						fill="url(#paint0_radial_3130_23544)"
					/>
				</g>
				<defs>
					<filter
						id="filter0_b_3130_23544"
						x="-5.28799"
						y="-46.2881"
						width="250.896"
						height="250.897"
						filterUnits="userSpaceOnUse"
						colorInterpolationFilters="sRGB"
					>
						<feFlood floodOpacity="0" result="BackgroundImageFix" />
						<feGaussianBlur in="BackgroundImageFix" stdDeviation="3.06587" />
						<feComposite
							in2="SourceAlpha"
							operator="in"
							result="effect1_backgroundBlur_3130_23544"
						/>
						<feBlend
							mode="normal"
							in="SourceGraphic"
							in2="effect1_backgroundBlur_3130_23544"
							result="shape"
						/>
					</filter>
					<radialGradient
						id="paint0_radial_3130_23544"
						cx="0"
						cy="0"
						r="1"
						gradientUnits="userSpaceOnUse"
						gradientTransform="translate(85.9696 114.445) rotate(-5.90031) scale(176.85 177.44)"
					>
						<stop stopColor="#8B89FF" stopOpacity="0.1" />
						<stop offset="0.598958" stopColor="#7C79FF" stopOpacity="0.58" />
						<stop offset="1" stopColor="#7C79FF" />
					</radialGradient>
				</defs>
			</svg>

			<svg
				width="97"
				height="109"
				viewBox="0 0 97 109"
				fill="none"
				xmlns="http://www.w3.org/2000/svg"
				style={{
					position: "absolute",
					bottom: "40px",
					left: "40px",
					opacity: 0.7,
				}}
			>
				<g filter="url(#filter0_b_2688_26453)">
					<path
						d="M5.37184 45.3145C-1.11829 48.9702 -1.18188 58.2817 5.25737 62.0747L81.4414 106.95C87.881 110.744 95.9938 106.174 96.0447 98.7249L96.646 10.5991C96.6965 3.15019 88.6473 -1.59117 82.1572 2.06454L5.37184 45.3145Z"
						fill="url(#paint0_linear_2688_26453)"
						fillOpacity="0.8"
					/>
				</g>
				<defs>
					<filter
						id="filter0_b_2688_26453"
						x="-19.5332"
						y="-19.1954"
						width="136.18"
						height="147.509"
						filterUnits="userSpaceOnUse"
						colorInterpolationFilters="sRGB"
					>
						<feFlood floodOpacity="0" result="BackgroundImageFix" />
						<feGaussianBlur in="BackgroundImageFix" stdDeviation="10" />
						<feComposite
							in2="SourceAlpha"
							operator="in"
							result="effect1_backgroundBlur_2688_26453"
						/>
						<feBlend
							mode="normal"
							in="SourceGraphic"
							in2="effect1_backgroundBlur_2688_26453"
							result="shape"
						/>
					</filter>
					<linearGradient
						id="paint0_linear_2688_26453"
						x1="33.3029"
						y1="96.212"
						x2="91.6983"
						y2="1.93918"
						gradientUnits="userSpaceOnUse"
					>
						<stop stopColor="#06F5BC" stopOpacity="0.1" />
						<stop offset="1" stopColor="#032BFF" stopOpacity="0.6" />
					</linearGradient>
				</defs>
			</svg>

			<svg
				width="231"
				height="444"
				viewBox="0 0 231 444"
				fill="none"
				xmlns="http://www.w3.org/2000/svg"
				style={{
					position: "absolute",
					bottom: "100px",
					right: "-30px",
					opacity: 0.7,
				}}
			>
				<g filter="url(#filter0_b_2688_26452)">
					<path
						d="M13.7366 267.132C-9.14268 288.761 0.117916 327.014 30.4052 335.986L388.74 442.129C419.029 451.101 447.628 424.062 440.22 393.462L352.573 31.4243C345.164 0.822981 307.304 -10.3916 284.425 11.2377L13.7366 267.132Z"
						fill="url(#paint0_linear_2688_26452)"
						fillOpacity="0.8"
					/>
				</g>
				<defs>
					<filter
						id="filter0_b_2688_26452"
						x="-19.0332"
						y="-19.9821"
						width="480.436"
						height="483.857"
						filterUnits="userSpaceOnUse"
						colorInterpolationFilters="sRGB"
					>
						<feFlood floodOpacity="0" result="BackgroundImageFix" />
						<feGaussianBlur in="BackgroundImageFix" stdDeviation="10" />
						<feComposite
							in2="SourceAlpha"
							operator="in"
							result="effect1_backgroundBlur_2688_26452"
						/>
						<feBlend
							mode="normal"
							in="SourceGraphic"
							in2="effect1_backgroundBlur_2688_26452"
							result="shape"
						/>
					</filter>
					<linearGradient
						id="paint0_linear_2688_26452"
						x1="180.333"
						y1="447.312"
						x2="323.426"
						y2="0.967336"
						gradientUnits="userSpaceOnUse"
					>
						<stop stopColor="#06F5BC" stopOpacity="0.1" />
						<stop offset="1" stopColor="#032BFF" stopOpacity="0.6" />
					</linearGradient>
				</defs>
			</svg>

			<svg
				width="42"
				height="47"
				viewBox="0 0 42 47"
				fill="none"
				xmlns="http://www.w3.org/2000/svg"
				style={{
					position: "absolute",
					top: "150px",
					left: "calc(50% - 21px)",
					opacity: 0.7,
				}}
			>
				<path
					d="M6.89625 0.565347C4.11471 -1.04239 0.637577 0.967407 0.637578 4.18288L0.637584 42.2258C0.637585 45.4414 4.11472 47.4511 6.89626 45.8433L39.8045 26.822C42.586 25.214 42.586 21.1946 39.8045 19.5869L6.89625 0.565347Z"
					fill="url(#paint0_linear_2688_26454)"
					fillOpacity="0.5"
				/>
				<defs>
					<linearGradient
						id="paint0_linear_2688_26454"
						x1="-5.19165"
						y1="40.1617"
						x2="41.7061"
						y2="11.7436"
						gradientUnits="userSpaceOnUse"
					>
						<stop stopColor="#F106F5" stopOpacity="0.2" />
						<stop offset="1" stopColor="#032BFF" stopOpacity="0.8" />
					</linearGradient>
				</defs>
			</svg>

			<svg
				width="648"
				height="527"
				viewBox="0 0 648 527"
				fill="none"
				xmlns="http://www.w3.org/2000/svg"
				className="middle-section"
			>
				<path
					d="M2.20915 119.568C18.7441 33.3408 90.6696 -23.0733 182.79 9.19898C253.573 33.9939 341.351 99.843 421.402 68.9772C551.163 18.9442 689.04 143.266 635.903 325.34C587.557 491.013 335.978 618.125 254.565 443.549C186.719 298.073 120.149 349.168 51.1492 287.921C-2.06545 240.685 -3.36906 148.659 2.20915 119.568Z"
					fill="#F1F3F9"
				/>
				<path
					d="M2.20915 119.568C18.7441 33.3408 90.6696 -23.0733 182.79 9.19898C253.573 33.9939 341.351 99.843 421.402 68.9772C551.163 18.9442 689.04 143.266 635.903 325.34C587.557 491.013 335.978 618.125 254.565 443.549C186.719 298.073 109.873 436.061 40.8725 374.814C-12.3422 327.578 -3.36906 148.659 2.20915 119.568Z"
					fill="#E3E2FF"
				/>
				<path
					d="M150.184 128.403C160.271 126.673 170.246 124.317 180.053 121.351C178.204 127.557 174.7 133.115 169.934 137.405C165.169 141.694 159.329 144.545 153.068 145.639C146.806 146.733 140.37 146.028 134.479 143.601C128.588 141.174 123.474 137.122 119.709 131.897C129.927 131.363 140.104 130.197 150.184 128.403Z"
					fill="#00FFA3"
					fillOpacity="0.8"
				/>
				<path
					d="M181.042 105.28C181.722 109.301 181.702 113.414 180.984 117.429C170.707 120.673 160.226 123.202 149.613 124.997C139.016 126.908 128.305 128.083 117.552 128.513C115.568 124.971 114.21 121.099 113.541 117.075C113.114 114.531 112.964 111.948 113.091 109.37C113.153 108.108 113.283 106.851 113.481 105.603C114.622 98.4046 117.938 91.75 122.965 86.5703C127.991 81.3906 134.477 77.9448 141.516 76.7148C148.554 75.4847 155.793 76.5319 162.22 79.71C168.648 82.8881 173.941 88.038 177.361 94.4397C177.955 95.5488 178.487 96.6907 178.956 97.86C179.917 100.247 180.616 102.735 181.042 105.28Z"
					fill="#00FFA3"
					fillOpacity="0.8"
				/>
				<path
					d="M209.498 102.391C210.602 108.982 197.76 115.88 180.052 121.35C180.44 120.063 180.75 118.753 180.983 117.428C197.665 112.032 206.707 106.227 206.162 102.974C205.63 99.7974 195.69 97.4328 178.957 97.8587C178.488 96.6894 177.956 95.5475 177.363 94.4384C194.97 93.7982 208.429 96.0134 209.498 102.391Z"
					fill="white"
				/>
				<path
					d="M180.983 117.428C180.75 118.753 180.44 120.063 180.052 121.35C170.245 124.317 160.27 126.672 150.182 128.402C140.103 130.196 129.926 131.362 119.708 131.896C118.924 130.813 118.204 129.683 117.553 128.512C128.306 128.082 139.018 126.907 149.615 124.996C160.226 123.2 170.706 120.672 180.983 117.428Z"
					fill="white"
				/>
				<path
					d="M119.709 131.897C101.228 132.751 86.8702 130.606 85.7654 124.015C84.6969 117.636 96.6781 110.976 113.483 105.602C113.285 106.85 113.154 108.107 113.093 109.369C97.1739 114.65 88.5688 120.255 89.1009 123.431C89.6457 126.684 100.072 129.086 117.553 128.512C118.204 129.683 118.925 130.814 119.709 131.897Z"
					fill="white"
				/>
				<path
					d="M271.511 90.9181C273.019 90.9181 274.242 89.6695 274.242 88.1293C274.242 86.5891 273.019 85.3405 271.511 85.3405C270.003 85.3405 268.78 86.5891 268.78 88.1293C268.78 89.6695 270.003 90.9181 271.511 90.9181Z"
					fill="white"
				/>
				<path
					d="M274.475 156.286C277.217 156.286 279.44 154.015 279.44 151.215C279.44 148.414 277.217 146.143 274.475 146.143C271.732 146.143 269.509 148.414 269.509 151.215C269.509 154.015 271.732 156.286 274.475 156.286Z"
					fill="white"
				/>
				<path
					d="M486.264 137.063C489.006 137.063 491.229 134.793 491.229 131.992C491.229 129.191 489.006 126.921 486.264 126.921C483.521 126.921 481.298 129.191 481.298 131.992C481.298 134.793 483.521 137.063 486.264 137.063Z"
					fill="white"
				/>
				<path
					d="M416.746 212.51C420.648 212.51 423.812 209.279 423.812 205.294C423.812 201.308 420.648 198.077 416.746 198.077C412.843 198.077 409.679 201.308 409.679 205.294C409.679 209.279 412.843 212.51 416.746 212.51Z"
					fill="white"
				/>
				<path
					d="M191.904 263.667C193.324 263.667 194.475 262.491 194.475 261.041C194.475 259.591 193.324 258.416 191.904 258.416C190.484 258.416 189.333 259.591 189.333 261.041C189.333 262.491 190.484 263.667 191.904 263.667Z"
					fill="white"
				/>
				<path
					d="M75.4141 182.124C79.4101 182.124 82.6496 178.815 82.6496 174.734C82.6496 170.653 79.4101 167.345 75.4141 167.345C71.4181 167.345 68.1787 170.653 68.1787 174.734C68.1787 178.815 71.4181 182.124 75.4141 182.124Z"
					fill="white"
				/>
				<path
					d="M90.2481 273.446C92.4729 273.446 94.2765 271.604 94.2765 269.332C94.2765 267.06 92.4729 265.218 90.2481 265.218C88.0232 265.218 86.2196 267.06 86.2196 269.332C86.2196 271.604 88.0232 273.446 90.2481 273.446Z"
					fill="white"
				/>
				<path
					d="M580.842 219.971C584.811 219.971 588.028 216.685 588.028 212.632C588.028 208.578 584.811 205.292 580.842 205.292C576.873 205.292 573.655 208.578 573.655 212.632C573.655 216.685 576.873 219.971 580.842 219.971Z"
					fill="white"
				/>
				<path
					d="M509.766 236.778C511.776 236.778 513.407 235.113 513.407 233.059C513.407 231.006 511.776 229.341 509.766 229.341C507.755 229.341 506.125 231.006 506.125 233.059C506.125 235.113 507.755 236.778 509.766 236.778Z"
					fill="white"
				/>
				<path
					d="M86.2207 58.7362C88.2316 58.7362 89.8617 57.0714 89.8617 55.0178C89.8617 52.9642 88.2316 51.2995 86.2207 51.2995C84.2098 51.2995 82.5797 52.9642 82.5797 55.0178C82.5797 57.0714 84.2098 58.7362 86.2207 58.7362Z"
					fill="white"
				/>
				<path
					d="M301.37 225.76C304.012 225.76 306.154 223.572 306.154 220.874C306.154 218.176 304.012 215.989 301.37 215.989C298.728 215.989 296.586 218.176 296.586 220.874C296.586 223.572 298.728 225.76 301.37 225.76Z"
					fill="white"
				/>
				<path
					d="M150.887 219.972C152.872 219.972 154.481 218.329 154.481 216.302C154.481 214.276 152.872 212.632 150.887 212.632C148.902 212.632 147.293 214.276 147.293 216.302C147.293 218.329 148.902 219.972 150.887 219.972Z"
					fill="white"
				/>
				<path
					d="M527.585 332.801C531.76 332.801 535.144 329.345 535.144 325.082C535.144 320.819 531.76 317.363 527.585 317.363C523.411 317.363 520.027 320.819 520.027 325.082C520.027 329.345 523.411 332.801 527.585 332.801Z"
					fill="white"
				/>
				<path
					d="M619.811 274.299C622.267 274.299 624.258 272.266 624.258 269.759C624.258 267.251 622.267 265.218 619.811 265.218C617.356 265.218 615.365 267.251 615.365 269.759C615.365 272.266 617.356 274.299 619.811 274.299Z"
					fill="white"
				/>
				<path
					d="M269.641 324.435C272.31 324.435 274.474 322.225 274.474 319.499C274.474 316.773 272.31 314.563 269.641 314.563C266.972 314.563 264.808 316.773 264.808 319.499C264.808 322.225 266.972 324.435 269.641 324.435Z"
					fill="white"
				/>
				<path
					d="M347.978 481.379C351.131 481.379 353.688 478.768 353.688 475.547C353.688 472.326 351.131 469.715 347.978 469.715C344.824 469.715 342.267 472.326 342.267 475.547C342.267 478.768 344.824 481.379 347.978 481.379Z"
					fill="white"
				/>
				<path
					d="M525.415 426.473C529.384 426.473 532.602 423.187 532.602 419.134C532.602 415.081 529.384 411.795 525.415 411.795C521.446 411.795 518.229 415.081 518.229 419.134C518.229 423.187 521.446 426.473 525.415 426.473Z"
					fill="white"
				/>
				<path
					d="M454.342 443.28C456.353 443.28 457.983 441.615 457.983 439.562C457.983 437.508 456.353 435.843 454.342 435.843C452.332 435.843 450.701 437.508 450.701 439.562C450.701 441.615 452.332 443.28 454.342 443.28Z"
					fill="white"
				/>
				<path
					d="M423.811 288.764C427.985 288.764 431.369 285.308 431.369 281.045C431.369 276.782 427.985 273.326 423.811 273.326C419.636 273.326 416.252 276.782 416.252 281.045C416.252 285.308 419.636 288.764 423.811 288.764Z"
					fill="white"
				/>
				<path
					d="M580.841 347.484C583.297 347.484 585.288 345.451 585.288 342.943C585.288 340.435 583.297 338.402 580.841 338.402C578.386 338.402 576.395 340.435 576.395 342.943C576.395 345.451 578.386 347.484 580.841 347.484Z"
					fill="white"
				/>
				<path
					d="M428.866 154.099C428.72 153.869 428.371 153.429 428.096 153.076L427.172 151.941C426.545 151.181 425.888 150.42 425.218 149.669C423.886 148.159 422.481 146.685 421.047 145.237C418.154 142.331 415.116 139.579 411.945 136.993C405.575 131.745 398.617 127.288 391.219 123.713C387.496 121.909 383.646 120.389 379.703 119.166C375.732 117.908 371.668 116.984 367.55 116.402L365.996 116.169C365.477 116.098 364.956 116.068 364.435 116.015L361.296 115.733L358.142 115.637C357.615 115.628 357.084 115.592 356.557 115.604L354.974 115.654C350.712 115.763 346.464 116.214 342.27 117.001C346.337 115.518 350.511 114.363 354.755 113.545L356.362 113.226C356.897 113.125 357.438 113.071 357.977 112.992L361.226 112.551L364.501 112.303C365.048 112.267 365.6 112.209 366.145 112.193L367.792 112.165C372.216 112.056 376.642 112.316 381.025 112.943C385.446 113.547 389.818 114.485 394.104 115.748C402.745 118.287 411.061 121.863 418.879 126.399C422.822 128.662 426.648 131.131 430.342 133.796C432.195 135.139 434.025 136.523 435.821 137.988C436.723 138.717 437.616 139.462 438.506 140.24L439.845 141.425C440.312 141.857 440.703 142.202 441.276 142.783L441.813 143.326C442.597 144.118 443.22 145.06 443.648 146.098C444.075 147.137 444.298 148.251 444.304 149.377C444.309 150.503 444.098 151.62 443.681 152.663C443.264 153.705 442.65 154.654 441.875 155.455C441.099 156.255 440.176 156.892 439.159 157.328C438.143 157.765 437.052 157.992 435.949 157.998C434.846 158.004 433.753 157.788 432.732 157.362C431.711 156.937 430.782 156.31 429.998 155.517C429.575 155.085 429.195 154.61 428.866 154.099Z"
					fill="#EDECFF"
				/>
				<path
					d="M436.842 159.169C441.622 159.169 445.496 155.212 445.496 150.331C445.496 145.45 441.622 141.493 436.842 141.493C432.062 141.493 428.188 145.45 428.188 150.331C428.188 155.212 432.062 159.169 436.842 159.169Z"
					fill="white"
				/>
				<path
					d="M378.161 426.109C409.333 426.109 434.602 400.302 434.602 368.468C434.602 336.634 409.333 310.827 378.161 310.827C346.99 310.827 321.72 336.634 321.72 368.468C321.72 400.302 346.99 426.109 378.161 426.109Z"
					fill="#9C79FF"
					fillOpacity="0.8"
				/>
				<path
					d="M359.543 375.131C365.165 375.131 369.722 370.477 369.722 364.735C369.722 358.994 365.165 354.34 359.543 354.34C353.921 354.34 349.363 358.994 349.363 364.735C349.363 370.477 353.921 375.131 359.543 375.131Z"
					fill="#B299FF"
				/>
				<path
					d="M387.847 350.689C395.585 350.689 401.857 344.283 401.857 336.381C401.857 328.478 395.585 322.072 387.847 322.072C380.109 322.072 373.836 328.478 373.836 336.381C373.836 344.283 380.109 350.689 387.847 350.689Z"
					fill="#B299FF"
				/>
				<path
					d="M553.011 228.532C551.979 231.213 550.691 233.783 549.166 236.206C543.834 244.638 535.809 250.925 526.454 254C517.098 257.076 506.989 256.75 497.842 253.077C488.695 249.405 481.075 242.613 476.274 233.855C471.474 225.096 469.79 214.911 471.508 205.029C472.614 198.737 475.054 192.769 478.658 187.542C484.158 179.609 492.104 173.788 501.224 171.008C510.345 168.229 520.114 168.651 528.972 172.207C537.831 175.763 545.266 182.248 550.092 190.627C554.917 199.005 556.854 208.794 555.593 218.428C555.132 221.89 554.265 225.282 553.011 228.532Z"
					fill="#F106F5"
					fillOpacity="0.97"
				/>
				<path
					d="M555.589 218.428L478.654 187.542C482.152 182.478 486.678 178.244 491.923 175.129L554.151 200.111C555.914 206.041 556.404 212.288 555.589 218.428Z"
					fill="#FEE0FF"
					fillOpacity="0.97"
				/>
				<path
					d="M549.165 236.207C545.951 241.3 541.726 245.647 536.763 248.967L472.078 222.999C470.658 217.116 470.463 210.994 471.505 205.029L549.165 236.207Z"
					fill="#FEE0FF"
					fillOpacity="0.97"
				/>
			</svg>

			<div className="not-found">404</div>

			<div className="bottom-section">
				<p className="bottom-text">
					It looks like you've ventured into uncharted space. Let's get you back
					to the right path.
				</p>
				<div
					className="btn-container"
					onClick={() => {
						navigate(url);
					}}
				>
					<Button className="mt-5">Take me back to {module}</Button>
				</div>
			</div>
		</div>
	);
};

export default NotFoundPage;
